module.exports = __webpack_public_path__ + "static/media/popsicle-screenshot-1.7d15c027.png";